var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('form-table',{ref:"baseForm",attrs:{"queryOptions":_vm.searchFormData,"tableOptions":_vm.tableOptions,"headerTitle":_vm.headerTitle,"queryUrl":_vm.queryUrl,"btnData":_vm.btnData,"query-permission":['system:notice:query']},on:{"clickBtn":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }